<template lang="pug">
  div
    p.lead
      i.fa.fa-fw.fa-globe
      |
      |
      span ソーシャルサイト

    .row
      .form-group.col-md-6
        label(for="person__twitter_id") Twitter ID
        input.form-control#person__twitter_id(type="text", name="person[twitter_id]", v-model="data.twitter_id", :maxlength="maxlengths.twitter_id", @input="onInput('twitter_id', data.twitter_id)" data-testid="-input-twitter-id")

      .form-group.col-md-6
        label(for="person__blog_url") ブログURL
        input.form-control#person__blog_url(type="text", name="person[blog_url]", v-model="data.blog_url", :maxlength="maxlengths.blog_url", @input="onInput('blog_url', data.blog_url)" data-testid="-input-blog-url")

</template>

<script>
export default {
  name: 'SocialForm',
  props: {
    /**
     * ソーシャルサイト { twitter_id, blog_url }
     */
    value: { type: Object, required: true }
  },
  data () {
    return {
      data: {
        twitter_id: '',
        blog_url: ''
      },
      maxlengths: {}
    }
  },
  watch: {
    value (newval, oldval) {
      if (newval !== oldval) {
        this.syncData(newval)
      }
    }
  },
  created () {
    this.maxlengths = this.loadMaxlengths('Persons')
    this.syncData(this.value)
  },
  methods: {
    syncData (data) {
      this.data = data
    },
    onInput (index, value) {
      const data = this.data
      data[index] = value
      this.$emit('input', data)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/organisms/forms/SocialForm.vue